import styled from 'styled-components';
import { StyledProductMiniatureProps } from './ProductMiniature.types';

export const StyledProductMiniature = styled.article<StyledProductMiniatureProps>`
  .product-miniature__image {
    display: inline-block;
    img {
      display: block;
      max-width: 100%;
    }
  }

  ${(props) => props.customStyle}
`;
